import { Injectable, signal } from '@angular/core';
import { LocalStorageService } from '@client/app/shared-modules/storage/local-storage.service';
import { FilterResponse } from '@client/app/shared-modules/filter/types/filter.type';

@Injectable({
    providedIn: 'root',
})

export class MonFilterService {
    filterResponse = signal<FilterResponse>({});

    constructor (
        readonly localStorageService: LocalStorageService,
    ) {}

    getFilters (pageKey: string) : string | null {
        return this.localStorageService.getItem(pageKey);
    }

    saveFilters (pageKey: string, filters: string) : void {
        this.localStorageService.setItem(pageKey, filters);
    }

    clearFilters (pageKey: string) : void {
        this.localStorageService.removeItem(pageKey);
    }
}
